import React, { useState, useCallback } from "react";
// import SendMoneyPanel from "./components/SendMoneyPanel";
import TransactionTable from "./components/TransactionTable";
import StaffPaymentTable from "./components/StaffPaymentTable";

const StaffWalletDashboard = () => {
  const [transactions, setTransactions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const handleNewTransaction = useCallback((tx) => {
    setTransactions((prev) => [tx, ...prev]);
  }, []);

  return (
    <div className="min-h-screen w-full">
      <div className=" mx-auto w-full ">
        <StaffPaymentTable onOpenModal={() => setModalOpen(true)} />
      </div>

      {/* Send Money Modal */}
      {/* <SendMoneyModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onTransaction={handleNewTransaction}
      /> */}
    </div>
  );
};

export default StaffWalletDashboard;
